{
  "localhost": {
    "CROSSOCEANRTM": [],
    "PORTINFOLINK": []
  },
  "kt": {
    "NORFOLKLINESHIP": [],
    "CROSSOCEANRTM": [],
    "CLDN": [],
    "GEESTRTM": [],
    "SAMSKIP": []
  },
  "pcs": {
    "ALLIEDCARRIERS": [],
    "ATYDITHZEMKZ": [],
    "ALENJAWFJHTU": [],
    "TEST": [],
    "AMONSCO": [],
    "BGFREIGHT" : [],
    "BMA": [],
    "BPA": [],
    "BSDRTM": [],
    "CARGILL": [],
    "CARGILLNV": [],
    "CARGOW" : [],
    "CSHIPPING": [],
    "CROSSOCEANBV": [],
    "CLDN": [],
    "DHS": [],
    "DOUAAPELD": [],
    "DOES": [],
    "DPA": [],
    "DYNAMIC": [],
    "EMS": [],
    "EPSHIPPING": [],
    "ERACHAR": [],
    "EURONORDIC": [],
    "FOCUS": [],
    "GANSTRANSPORT": [],
    "GEESTRTM": [],
    "GEPUGGLOLYSV": [],
    "THYSSENKRUPP": [],
    "KQNEQAMNGLBM": [],
    "KVSA": [],
    "LKL": [],
    "MPAGENCIES": [],
    "MUELLERPOORT": [],
    "NORFOLKLINESHIP": [],
    "WICDPYECXSEM": [],
    "FAIRWAY": [],
    "FMSRTM": [],
    "FSA": [],
    "FORCOMRTM": [],
    "FRACHTCONTOR": [],
    "HDCHARTERING": [],
    "HWLZEZBOQTYX": [],
    "IMPERIALDEGRAVE": [],
    "INCHCAPE": [],
    "KUHLMAN": [],
    "LBHCUSTOMS": [],
    "OUDKERKRTM": [],
    "LENSVELD": [],
    "MARIPROBV": [],
    "MARITEAM": [],
    "MMAGENCIES": [],
    "METAALRTM": [],
    "MCSLOG": [],
    "MOOEWNOSCPKQ": [],
    "MSCRTM": ["NLRTM26019189"],
    "NAUTICASHIP": [],
    "NAUTILUS": [],
    "NAVONUS": [],
    "NEBAM": [],
    "NESTA": [],
    "NEWMAN": [],
    "NIRINTBV": [],
    "NOORDRIVER": [],
    "EIMSKIPBRR": [],
    "OBQGQOFBZLWV": [],
    "ROTTERDAMS": [],
    "RFXZTRGDIXDA": [],
    "SAMSKIP": [],
    "SEAMAR": [],
    "STEINWEG": [],
    "STENALINE": [],
    "WPS": [],
    "A2BMOERDIJK" : [],
    "OBC": [],
    "OVET": [],
    "PONSF": [],
    "REDHUB": [],
    "RHENUS": [],
    "RHEINTRANS": [],
    "SEACARGO" : [],
    "SEATRADE": [],
    "SEATRADERTM": [],
    "SERROMAH": [],
    "STT": [],
    "TALARIA": [],
    "THORSHIPPING": [],
    "TRANSSAAR": [],
    "TRANSITO": [],
    "VCK": [],
    "VERTOM": [],
    "VERBRUGGEBV": [],
    "VISSER": [],
    "VSCHARTERING": [],
    "WAGENBORG": [],
    "WAYPOINT": [],
    "WEB": [],
    "WIJNNECONTAINER": [],
    "WILSONAGENCY": [],
    "SILVERSTAR": [],
    "LIBRASHIPPING": [],
    "VOPAKAGENCIES": [],
    "XPRESSLINE": [],
    "ZPOLPYVEEMNI": [],
    "HMISPJBVHRYR": []
  }
}
